const EMOJI_REGEX = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{2B55}\u{FE0F}\u{200D}]/u;

export const CATEGORY_REQUIRED_MESSAGE = "This field is required !";
export const CATEGORY_EMOJI_MESSAGE = "Emojis are not allowed in category name.";
export const CATEGORY_FORMAT_MESSAGE = "Use letters, numbers, spaces, and common punctuation (& , ' . / -).";
export const CATEGORY_MAX_LENGTH = 100;
export const CATEGORY_LENGTH_MESSAGE = `Category name cannot exceed ${CATEGORY_MAX_LENGTH} characters.`;

export function normalizeCategoryName(value: unknown): string {
  return String(value ?? "").trim();
}

export function validateCategoryName(value: unknown): string {
  const normalizedValue = normalizeCategoryName(value);

  if (!normalizedValue) {
    return CATEGORY_REQUIRED_MESSAGE;
  }

  if (normalizedValue.length > CATEGORY_MAX_LENGTH) {
    return CATEGORY_LENGTH_MESSAGE;
  }

  if (EMOJI_REGEX.test(normalizedValue)) {
    return CATEGORY_EMOJI_MESSAGE;
  }

  if (!/[\p{L}\p{N}]/u.test(normalizedValue) || !/^(?:[\p{L}\p{N}]|[\p{L}\p{N}][\p{L}\p{N}\s&,'()./-]*[\p{L}\p{N}])$/u.test(normalizedValue)) {
    return CATEGORY_FORMAT_MESSAGE;
  }

  return "";
}
